/**
 * AES-256-GCM decryption for the dspi/dsps served by the admin portal.
 * Payload layout is base64 of iv || body || tag, produced by ./dsp-cipher.js.
 */

const IV_LENGTH = 12;

const base64ToBytes = (value) => {
  const binary = atob(value);
  const bytes = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i += 1) {
    bytes[i] = binary.charCodeAt(i);
  }
  return bytes;
};

const importKey = (rawKey) => window.crypto.subtle.importKey(
  'raw',
  base64ToBytes(rawKey),
  { name: 'AES-GCM' },
  false,
  ['decrypt'],
);

const decryptValue = async (key, payload) => {
  const raw = base64ToBytes(payload);
  const plain = await window.crypto.subtle.decrypt(
    { name: 'AES-GCM', iv: raw.slice(0, IV_LENGTH) },
    key,
    raw.slice(IV_LENGTH),
  );
  return new TextDecoder().decode(plain);
};

/** Decrypt dspi and dsps with a single imported key. */
export const decryptDspPair = async (rawKey, pair) => {
  const key = await importKey(rawKey);
  const [dspi, dsps] = await Promise.all([
    decryptValue(key, pair.dspi),
    decryptValue(key, pair.dsps),
  ]);
  return { dspi, dsps };
};

export default decryptDspPair;
